import Resource from './Resource';

export default class Lunches extends Resource {
	constructor(options={}) {
		let {
			route = 'lunches',
			query = {}
		} = options;

		let config = {
			route: route,
			query: query,
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
